// ============================================
// PIPELINE CHART COMPONENT
// ============================================
// Bar chart showing lead distribution by pipeline status
// ============================================

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList
} from 'recharts';

const PipelineChart = ({ data }) => {
  // Status colors
  const COLORS = {
    'Initial Contact': '#3b82f6',    // blue
    'Qualified': '#10b981',           // emerald
    'Proposal Sent': '#f59e0b',       // amber
    'Negotiation': '#8b5cf6',         // purple
    'Closed Won': '#10b981',          // emerald
    'Closed Lost': '#ef4444',         // red
    'On Hold': '#6b7280',             // gray
    'Blue sky': '#3b82f6',            // blue
    'Project execution': '#10b981'    // emerald
  };

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const total = data.reduce((sum, item) => sum + item.count, 0);
      const percentage = ((payload[0].value / total) * 100).toFixed(1);
      
      return (
        <div className="bg-slate-800 border border-slate-700 rounded-lg p-3 shadow-lg">
          <p className="text-slate-300 text-sm font-medium mb-1">
            {payload[0].payload.status}
          </p>
          <p className="text-white text-sm">
            Count: {payload[0].value}
          </p>
          <p className="text-slate-400 text-xs">
            {percentage}% of total
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis 
          dataKey="status" 
          stroke="#94a3b8"
          angle={-45}
          textAnchor="end"
          height={100}
          style={{ fontSize: '11px' }}
        />
        <YAxis 
          stroke="#94a3b8"
          style={{ fontSize: '12px' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar 
          dataKey="count" 
          radius={[8, 8, 0, 0]}
        >
          <LabelList 
            dataKey="count" 
            position="top" 
            style={{ fill: '#f1f5f9', fontSize: '12px', fontWeight: 'bold' }}
          />
          {data.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={COLORS[entry.status] || '#3b82f6'} 
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default PipelineChart;